const HALLOWEEN_DAY_OFFSET = 6;
const VALENTINES_DAY_OFFSET = 1;
const NEW_YEAR_DAYS_BEFORE = 21;
const NEW_YEAR_DAYS_AFTER = 14;

/**
 * Returns whether the current date is within the halloween celebration period.
 */
// If we support multiple celebration dates in the future, consider turning this into a generic function.
function isHalloween(): boolean {
    const currentDate = new Date();
    // eslint-disable-next-line no-magic-numbers
    const halloweenDate = new Date(currentDate.getFullYear(), 9, 31); // October is month 9 (0-based).

    const celebrationStartDate = new Date(halloweenDate);
    celebrationStartDate.setDate(halloweenDate.getDate() - HALLOWEEN_DAY_OFFSET);

    const endDate = new Date(halloweenDate);
    endDate.setDate(halloweenDate.getDate() + HALLOWEEN_DAY_OFFSET);

    return currentDate >= celebrationStartDate && currentDate <= endDate;
}

function isValentines(): boolean {
    const currentDate = new Date();
    // eslint-disable-next-line no-magic-numbers
    const valentinesDate = new Date(currentDate.getFullYear(), 1, 14); // February is month 1 (0-based).

    const celebrationStartDate = new Date(valentinesDate);
    celebrationStartDate.setDate(valentinesDate.getDate() - VALENTINES_DAY_OFFSET);

    const endDate = new Date(valentinesDate);
    endDate.setDate(valentinesDate.getDate() + VALENTINES_DAY_OFFSET);

    return currentDate >= celebrationStartDate && currentDate <= endDate;
}

function isNewYear(): boolean {
    const currentDate = new Date();
    const month = currentDate.getMonth();
    const day = currentDate.getDate();

    if (month === 0 && day <= NEW_YEAR_DAYS_AFTER) { // January 1-14
        return true;
    }

    // eslint-disable-next-line no-magic-numbers
    if (month === 11 && day >= 31 - NEW_YEAR_DAYS_BEFORE) { // December 10-31
        return true;
    }

    return false;
}

export {
    isHalloween,
    isValentines,
    isNewYear
};
